import { Component, OnInit } from '@angular/core';
import { PopoverRef } from '../popover/popover-ref';
import { Icons } from '@vex/icons/icons';
import { TooltipReadMoreComponent } from './tooltip-read-more/tooltip-read-more.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'popover-tooltip',
  templateUrl: './popover-tooltip.component.html',
  styleUrls: ['./popover-tooltip.component.scss']
})

export class PopoverTooltipComponent extends Icons implements OnInit {
  
  data: any;
  isHideButton: boolean = false;
  isShowReadmore: boolean = false;
  constructor(
    private dialog: MatDialog,
    private popoverRef: PopoverRef<PopoverTooltipComponent>
  ) {  
    super();
  }

  ngOnInit() {
    this.data = this.popoverRef.data;
    this.isShowReadmore = this.popoverRef?.data?.isShowReadmore;
    if(this.data.isHideButton) {
      this.isHideButton = true;
    }
  }

  close() {
    this.popoverRef.close();
  }

  toggleReadMore(text, heading){
    const dialogRef = this.dialog.open(TooltipReadMoreComponent, {
      width: '80%',
      maxWidth: '98vw',
      height: '80%',
      maxHeight: '80vw',
      disableClose: true,
      data: {Text: text, Heading: heading}
    });
  }
}
